import {
  fetchProductById as fetchProductByIdService,
  adjustInventory as adjustInventoryService,
} from '@/services/Products/product.services';
import { BaseActionType } from '@/types';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchProductById = createAsyncThunk(
  'singleProduct/fetchProduct',
  async (id: string, { rejectWithValue }) => {
    try {
      const product = await fetchProductByIdService(id);
      return product;
    } catch (error) {
      return rejectWithValue('Error fetching product');
    }
  },
);

export const refetchProductById = createAsyncThunk(
  'singleProduct/refetchProduct',
  async (id: string, { rejectWithValue }) => {
    try {
      const product = await fetchProductByIdService(id);
      return product;
    } catch (error) {
      return rejectWithValue('Error fetching product');
    }
  },
);

export const adjustInventory = createAsyncThunk(
  'singleProduct/adjustInventory',
  async (data: {
    productId: string;
    variantId: string;
    companyId: string;
    outletId: string;
    userId: string;
    specificAction: string;
    baseAction: BaseActionType;
    quantity: number;
  }) => {
    try {
      return await adjustInventoryService(data);
    } catch (error) {
      console.error('Error adjusting inventory', error);
    }
  },
);
